/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Add = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <rect x="2" y="11" width="20" height="1.5" fill={color} />
                    <rect
                        x="12.75"
                        y="2"
                        width="20"
                        height="1.5"
                        transform="rotate(90 12.75 2)"
                        fill={color}
                    />
                </svg>
        );
    };
